import { axiosInstance } from 'boot/axios';
import RequestHealthCard from 'src/models/requestHealthCard.js';
import DigitalInsuranceCardInformation from 'src/models/digitalInsuranceCardInformation.js';

export function applyForInsuranceCard({ commit }, customerNumbers) {
  return axiosInstance.post('InsuranceCard', customerNumbers).then((response) => {
    commit('setRequestHealthCard', new RequestHealthCard(response.data));
  });
}

export function getDigitalInsuranceCardInformation({ commit, rootState }, payload) {
  if (!rootState.user.permissions.mayCreateEHIC) return;
  return axiosInstance.post('InsuranceCard/GetDigitalInsuranceCardInformation', payload).then((response) => {
    const results = response.data.map((x) => new DigitalInsuranceCardInformation(x));
    commit('setDigitalInsuranceCardInformation', results);
  });
}

export function setShowRequestAcceptedDialog({ commit }, payload) {
  commit('setShowRequestAcceptedDialog', payload);
}

export function setShowRequestPartiallyAcceptedDialog({ commit }, payload) {
  commit('setShowRequestPartiallyAcceptedDialog', payload);
}

export function setShowRequestDeniedDialog({ commit }, payload) {
  commit('setShowRequestDeniedDialog', payload);
}
